import React from "react";
import AppDropdown from "../../../components/AppDropdown/AppDropdown";
import { SecondaryButton } from "../hrComponents";
import { inputStyle, iconBtnStyle } from "../hrUi";

// Edits the lines of a salary structure: which components, and how each is worked out from the CTC.
//   FIXED a set amount | PERCENT a percentage of another component or of CTC | BALANCE whatever is left of the CTC
// The server checks the sums; this only collects the lines. line: { component_id, calc_type, amount, percent, percent_of }
const CALC = [
  { label: "Fixed amount", value: "FIXED" },
  { label: "Percent of…", value: "PERCENT" },
  { label: "Balance of CTC", value: "BALANCE" },
];

export const emptyLine = () => ({ component_id: null, calc_type: "FIXED", amount: "", percent: "", percent_of: "CTC" });

// The lines as the API takes them: only what applies to the chosen calculation.
export const cleanLines = (lines) =>
  lines.map((l) => ({
    component_id: l.component_id,
    calc_type: l.calc_type,
    ...(l.calc_type === "FIXED" ? { amount: Number(l.amount) } : {}),
    ...(l.calc_type === "PERCENT" ? { percent: Number(l.percent), percent_of: l.percent_of || "CTC" } : {}),
  }));

export default function StructureEditor({ lines, onChange, components }) {
  const earnings = (components || []).filter((c) => c.kind === "EARNING" && c.status !== "INACTIVE");
  const options = earnings.map((c) => ({ label: `${c.name} (${c.code})`, value: c.id }));
  const codeOf = (id) => (earnings.find((c) => c.id === id) || {}).code;
  const set = (i, patch) => onChange(lines.map((l, k) => (k === i ? { ...l, ...patch } : l)));
  const percentOfOptions = (i) => [{ label: "CTC", value: "CTC" }, ...lines.map((l, k) => ({ l, k })).filter(({ l, k }) => k !== i && l.component_id).map(({ l }) => ({ label: codeOf(l.component_id) || "?", value: codeOf(l.component_id) }))];

  return (
    <div data-testid="structure-editor">
      {lines.map((l, i) => (
        <div key={i} className="mb-3 p-2" style={{ border: "1px solid #E5E7EB", borderRadius: 8 }}>
          <div className="d-flex gap-2 align-items-start">
            <div style={{ flex: 2 }}>
              <AppDropdown value={l.component_id ?? null} options={options} onChange={(e) => set(i, { component_id: e.value ?? null })} placeholder="Component" />
            </div>
            <div style={{ flex: 1.4 }}>
              <AppDropdown value={l.calc_type} options={CALC} onChange={(e) => set(i, { calc_type: e.value || "FIXED" })} />
            </div>
            <button type="button" style={iconBtnStyle} aria-label="Remove line" onClick={() => onChange(lines.filter((_, k) => k !== i))}>
              ✕
            </button>
          </div>
          {l.calc_type === "FIXED" ? (
            <input className="form-control mt-2" style={inputStyle} type="number" min="0" step="0.01" placeholder="Monthly amount" aria-label="Monthly amount" value={l.amount ?? ""} onChange={(e) => set(i, { amount: e.target.value })} />
          ) : null}
          {l.calc_type === "PERCENT" ? (
            <div className="d-flex gap-2 mt-2">
              <input className="form-control" style={{ ...inputStyle, flex: 1 }} type="number" min="0" step="0.01" placeholder="%" aria-label="Percent" value={l.percent ?? ""} onChange={(e) => set(i, { percent: e.target.value })} />
              <div style={{ flex: 1.4 }}>
                <AppDropdown value={l.percent_of || "CTC"} options={percentOfOptions(i)} onChange={(e) => set(i, { percent_of: e.value || "CTC" })} />
              </div>
            </div>
          ) : null}
        </div>
      ))}
      <SecondaryButton onClick={() => onChange([...lines, emptyLine()])}>Add a component</SecondaryButton>
      <div style={{ fontSize: 12, color: "#6B7280", marginTop: 8 }}>The components must add up to the CTC exactly, or one of them can be the balance.</div>
    </div>
  );
}
